import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import Product2skill2exp2rateDashboard from '../Product2skill2exp2rateDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';
import Product2skill2exp2ratePageImpl from './Product2skill2exp2ratePageImpl';

export default function Product2skill2exp2ratePage() {
    const dispatch = useDispatch();
    const { product2skill2exp2rateList} = useSelector((state)=>state.manufslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':true}));
    },[]);

    return (
        < Product2skill2exp2ratePageImpl />
    )

}